export class DashboardAverageTicketModel {
    value:number = 0
    date:Date|string|null = null

    constructor(d?:Partial<DashboardAverageTicketModel>) {
        Object.assign(this, d)
    }
}
